import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import Tile from '@divvy-web/skylab.tile'

import CheckWithIncludedLabel from '@sputnik/pages/PostApplicationPages/EligibleOffersPage/CheckWithIncludedLabel'

import styles from './styles.module.scss'

const IncludedWithOffers = () => {
  const [getClassName] = useNameFormatter('IncludedWithOffers')

  return (
    <Tile className={styles[getClassName('')]}>
      <div className={styles[getClassName('header')]}>
        <FormattedMessage
          defaultMessage='Included with all offers'
          id='sputnik.IncludedWithOffers__280Lvl'
        />
      </div>
      <div className={styles[getClassName('row')]}>
        <div className={styles[getClassName('row-text')]}>
          <div className={styles[getClassName('row-title')]}>
            <FormattedMessage
              defaultMessage='Bill Travel'
              id='sputnik.IncludedWithOffers__/96IXh'
            />
          </div>
          <div className={styles[getClassName('row-description')]}>
            <FormattedMessage
              defaultMessage='Connect booking with your travel expense workflow, so every trip stays tied to your travel budget, policies, and reporting. Access 500+ airlines and 1.5M hotels—and leave guesswork at the gate.'
              id='sputnik.IncludedWithOffers__Rhg6mK'
            />
          </div>
        </div>
        <CheckWithIncludedLabel />
      </div>
      <div className={styles[getClassName('row')]}>
        <div className={styles[getClassName('row-text')]}>
          <div className={styles[getClassName('row-title')]}>
            <FormattedMessage
              defaultMessage='Budget and spend controls'
              id='sputnik.IncludedWithOffers__Wp06rH'
            />
          </div>
          <div className={styles[getClassName('row-description')]}>
            <FormattedMessage
              defaultMessage='Set budgets and spend controls so cards stop at their limits, with policies like category restrictions and approval workflows to keep purchases aligned.'
              id='sputnik.IncludedWithOffers__hhJWLg'
            />
          </div>
        </div>
        <CheckWithIncludedLabel />
      </div>
    </Tile>
  )
}

export default IncludedWithOffers
